import Transfers from './Transfers'

export default Transfers
